import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const SPIN_MACHINE_ROUTES: Routes = [
  {
    path: 'spin-machine-theme',
    loadChildren: () =>
      import('./theme/theme.module').then((m) => m.SpinMachineThemeModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'spin-machine-games',
    loadChildren: () => import('./game/game.module').then((m) => m.GameModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'collectibles',
    loadChildren: () =>
      import('./collectible/collectible.module').then(
        (m) => m.CollectibleModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
      ],
    },
  },
  // {
  //   path: 'spins',
  //   loadChildren: () =>
  //     import('./spin-transactions/spin-transactions.module').then(
  //       (m) => m.SpinTransactionsModule,
  //     ),
  //   canActivate: [loggedInAuthGuard, checkPermissionGuard],
  //   data: {
  //     permission: [
  //       UserRole.Admin,
  //       UserRole.ClientAdmin,
  //       UserRole.Manager,
  //       UserRole.Supervisor,
  //       UserRole.CustomerSupport,
  //     ],
  //   },
  // },
  {
    path: 'icon-chances',
    loadChildren: () =>
      import('./icon-chance/icon-chance.module').then(
        (m) => m.IconChanceModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
      ],
    },
  },
];
